var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(_vm.user != null && this.$router.currentRoute.name != 'maintenance')?_c('Header',{staticStyle:{"width":"100%","position":"fixed","z-index":"999"}}):_vm._e(),_c('Sidebar'),_c('v-main',[_c('router-view')],1),(
        this.$router.currentRoute.name != 'maintenance' &&
        this.$router.currentRoute.name != 'chat' &&
        this.$router.currentRoute.name != 'voice-assistant'
      )?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }